import './index.scss';
import { Controller } from 'utils/stimulus';

export default class TrialSuccessController extends Controller {
  static targets = ['subscriptionText', 'daysText', 'illustration'];

  connect() {
    this.on('updateOffer', this.updateOffer.bind(this));
  }

  updateOffer(offer) {
    this.subscriptionTextTarget.textContent = offer.offerName;
    this.daysTextTarget.textContent = `${gon.flags.trial_settings.days} dias`;
    this.illustrationTarget.classList.add(
      `subscription-illustration--${offer.offerSubscription}`
    );
  }
}
